import Avatar from "./basic-19-avatar.png";
import LogoPlaceholder from "./logo-placeholder.png";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import Slide5 from "./preview/slide-5.png";
import BgOption1 from "./../images/bg-option-1.png";
import BgOption2 from "./../images/bg-option-2.png";
import BgOption3 from "./../images/bg-option-3.png";
import { MultilineView, TextView } from "../../components";
import BaseTemplate from "../base";

class Basic19 extends BaseTemplate {
  constructor() {
    super();
    this.name = "Basic #19";
    this.id = "19";
    this.url = "/ai/carousels/basic-19";
    this.description =
      "Create a simple and sleek carousel without the need for your image";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Jon Snow",
        },
        {
          label: "Profile Pic",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Avatar,
          },
        },
        {
          label: "Handle",
          type: "text",
          value: "@jon-snow",
        },
        {
          label: "Background",
          type: "background",
          key: "background_color",
          value: {
            type: "color",
            image: "",
            color: "#243555",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },
        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#87B3D7",
        },
        {
          label: "Secondary Color",
          type: "color",
          key: "secondary_color",
          style_key_group: "secondary",
          value: "#FFFFFF",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Fraunces",
          type: "font",
        },
        {
          label: "Secondary Font",
          key: "secondary_font",
          value: "Karla",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4, Slide5];
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Master Any Skill Quickly",
            max_words: 8,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "64px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Learn from brain coach, Jim Kwik`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "24px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              fontWeight: {
                value: "500",
              },
            },
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Brain's Learning Process",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "background_color",
              },
              fontSize: {
                value: "48px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `The brain learns three steps: information, meaning, and emotion. Combine all three for effective learning.`,
            max_words: 25,
            style: {
              color: {
                key: "background_color",
              },
              fontSize: {
                value: "20px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Power of Visualization",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "background_color",
              },
              fontSize: {
                value: "48px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Visualizing information makes it more memorable. Make your visualization vivid and engaging.`,
            max_words: 25,
            style: {
              color: {
                key: "background_color",
              },
              fontSize: {
                value: "20px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Take Breaks",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "background_color",
              },
              fontSize: {
                value: "48px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Memory improves when learning is spaced out. Regular breaks can help prevent cognitive fatigue.`,
            max_words: 25,
            style: {
              color: {
                key: "background_color",
              },
              fontSize: {
                value: "20px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "Liked this? I post about productivity 5/week",
            max_words: 2,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
              textAlign: {
                value: "center",
              },
            },
          },
          {
            label: "CTA Subtext",
            type: "text",
            target_key: "cta_text",
            value: "Follow for more",
            max_words: 2,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
              textAlign: {
                value: "center",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(common_settings) {
    return common_settings.elements[4].value;
  }

  getSecondaryColor(common_settings) {
    return common_settings.elements[5].value;
  }

  getBackgroundColor(common_settings) {
    return common_settings.elements[3].value.color;
  }

  getBackgroundColorVariant(common_settings) {
    return this.getBackgroundColor(common_settings) + "20";
  }

  getBackgroundColorVariantSecond(common_settings) {
    return this.getBackgroundColor(common_settings) + "40";
  }

  getPrimaryFont(common_settings) {
    return common_settings.elements[6]?.value || "Fraunces";
  }

  getSecondaryFont(common_settings) {
    return common_settings.elements[7]?.value || "Karla";
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderOutroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute h-full inset-x-0 flex items-center justify-center px-[24px]">
          <div className="w-full flex flex-col items-center gap-[32px]">
            <img
              className="object-cover w-[160px] h-[160px] rounded-full"
              src={
                commonSettings.elements[1].value.image
                  ? commonSettings.elements[1].value.image
                  : LogoPlaceholder
              }
              style={{
                backgroundColor: this.getBackgroundColor(commonSettings),
              }}
              alt=""
            />
            <div
              className="text-[36px] leading-[36px] font-semibold text-center"
              style={{
                color: this.getPrimaryColor(commonSettings),
                fontFamily: this.getPrimaryFont(commonSettings),
              }}
            >
              {slide.elements[0]?.style ? (
                <MultilineView
                  element={slide.elements[0]}
                  getPropertyByStyleKey={(styleKey) =>
                    this.getPropertyByStyleKey(styleKey, commonSettings)
                  }
                  getValueByKey={(key) =>
                    this.getValueByKey(key, commonSettings)
                  }
                />
              ) : (
                <TextView text={slide.elements[0]?.value} />
              )}
            </div>
            <div
              className="py-[8px] px-[24px] rounded-full"
              style={{
                backgroundColor: this.getPrimaryColor(commonSettings),
                color: this.getSecondaryColor(commonSettings),
                fontFamily: this.getPrimaryFont(commonSettings),
              }}
            >
              <div className="text-[14px] leading-[20px] font-semibold">
                {slide.elements[1]?.style ? (
                  <MultilineView
                    element={slide.elements[1]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, commonSettings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, commonSettings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[1]?.value} />
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  renderMiddleSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div
          className="absolute inset-x-0 top-[40px] px-[24px] flex flex-col gap-[16px]"
          style={{
            color: this.getBackgroundColor(commonSettings),
          }}
        >
          <div
            className="text-[48px] leading-[48px] font-semibold"
            style={{
              fontFamily: this.getPrimaryFont(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
          <div className="text-[20px] leading-[32px] font-normal">
            {slide.elements[1]?.style ? (
              <MultilineView
                element={slide.elements[1]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[1]?.value} />
            )}
          </div>
        </div>
      </>
    );
  }

  renderIntroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute inset-x-0 top-[40px] pl-[24px] pr-[40px] flex flex-col gap-[16px] items-center">
          <div
            className="text-[64px] leading-[64px] font-semibold"
            style={{
              color: this.getPrimaryColor(commonSettings),
              fontFamily: this.getPrimaryFont(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
          <div
            className="text-[24px] leading-[32px] font-medium uppercase"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[1]?.style ? (
              <MultilineView
                element={slide.elements[1]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[1]?.value} />
            )}
          </div>
        </div>
      </>
    );
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
        style={{
          fontFamily: this.getSecondaryFont(commonSettings),
        }}
      >
        <div className="absolute inset-0">
          {commonSettings.elements[3].value.type === "image" &&
            commonSettings.elements[3].value.image && (
              <img
                className="object-cover w-full h-full"
                src={commonSettings.elements[3].value.image}
                alt=""
              />
            )}
          {commonSettings.elements[3].value.type === "color" && (
            <>
              {index !== 0 && index !== carouselLength - 1 ? (
                <div
                  className="w-full h-full"
                  style={{
                    backgroundColor: this.getPrimaryColor(commonSettings),
                  }}
                />
              ) : (
                <div
                  className="w-full h-full"
                  style={{
                    backgroundColor: this.getBackgroundColor(commonSettings),
                  }}
                />
              )}
            </>
          )}
        </div>
        {index === 0 &&
          this.renderIntroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index === carouselLength - 1 &&
          this.renderOutroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index !== carouselLength - 1 &&
          index !== 0 &&
          this.renderMiddleSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index !== carouselLength - 1 && (
          <div className="absolute w-full inset-x-0 top-[420px] flex justify-center items-center">
            <div
              className="w-[352px] flex px-[10px] py-[8px] justify-between rounded-full"
              style={{
                backgroundColor: this.getSecondaryColor(commonSettings),
              }}
            >
              <div className="flex gap-[8px] items-center">
                <img
                  className="object-cover w-[40px] h-[40px] rounded-full"
                  src={
                    commonSettings.elements[1].value.image
                      ? commonSettings.elements[1].value.image
                      : LogoPlaceholder
                  }
                  style={{
                    backgroundColor: this.getPrimaryColor(commonSettings),
                  }}
                  alt=""
                />
                <div
                  className="flex flex-col"
                  style={{
                    color: this.getBackgroundColor(commonSettings),
                  }}
                >
                  <p
                    className=" text-[16px] leading-[24px] font-semibold whitespace-nowrap"
                    style={{
                      fontFamily: this.getPrimaryFont(commonSettings),
                    }}
                  >
                    {commonSettings.elements[0].value}
                  </p>
                  <p className=" text-[12px] leading-[18px]">
                    {commonSettings.elements[2].value}
                  </p>
                </div>
              </div>

              <div
                className="py-[8px] px-[24px] rounded-full flex items-center"
                style={{
                  backgroundColor: this.getBackgroundColor(commonSettings),
                  color: this.getSecondaryColor(commonSettings),
                  fontFamily: this.getPrimaryFont(commonSettings),
                }}
              >
                <p className="text-[14px] leading-[20px] font-semibold">
                  Swipe
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Basic19;
